import { Observable } from 'rxjs';
import { BaseIntegrationWebComponent } from '../../BaseIntegrationWebComponent';
import { IntegrationContainerImageScannerController } from '../controller/IntegrationContainerImageScannerController';
import { ContainerImageScannerSpecifics } from '../types';
import { IntegrationActionContext } from '../../../integrationsMarketplaceGridInstalled/types';
import { TagActionContext } from 'apps/webcomponents/src/tagsManager/common/types/TagActionContext';
import { Integration, IntegrationData } from '../../types';
import { Company } from 'apps/webcomponents/src/tagsManager/types/tag-data';
import { isHidden } from 'apps/webcomponents/src/utils/htmlElement.utils';

export class IntegrationContainerImageScannerWebComponent extends BaseIntegrationWebComponent<ContainerImageScannerSpecifics> {
  public controller!: IntegrationContainerImageScannerController;
  private viewData: Integration | null;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationContainerImageScannerController,
    });
  }

  // valid$ and valid are used when there is formGroup validation
  // returns null and false respectively if not applicable
  public get valid$(): Observable<boolean> | null {
    if (!this.controller.view.formGroup) {
      return null;
    }
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }

  public get formContext(): IntegrationActionContext {
    const context = this.getAttribute('context');

    if (!TagActionContext.isValid(context)) {
      throw new Error(`Container Image Scanner form context not valid: ${context}`);
    }

    return context as IntegrationActionContext;
  }

  public set formContext(context: IntegrationActionContext) {
    this.setAttribute('context', context);
  }

  public setActionContext(context: IntegrationActionContext): void {
    this.controller.view.context = context;
  }

  public setViewData(data: Integration | null): void {
    this.viewData = data;
  }

  public getViewData(): Integration | null {
    return this.viewData;
  }

  public setCompany(company: Company) {
    this.controller?.setCompany(company);
  }

  public setIntegrationId(id: string) {
    this.controller?.setIntegrationId(id);
  }

  public async setIntegrationData(integration: IntegrationData<ContainerImageScannerSpecifics>) {
    await this.controller.view.setIntegrationData(integration);
  }

  public getCompanyId(): string {
    return this.controller.view.dom.$companyFormField.value as string;
  }

  public getNameValue(): string {
    return this.controller.view.dom.$integrationNameFormField.value as string;
  }

  public getLastSync(): string | null {
    return (this.viewData as IntegrationData<ContainerImageScannerSpecifics>)?.specifics?.lastSync ?? null;
  }
}
